<div class="dnd-img-container">
  <img [src]="data.srcWidth"
       (error)="data.srcWidth = 'assets/img/default.png'"
       alt="{{data.name}}">
  <p class="dnd-title">{{data.name}}</p>
</div>
